import Recipe from './Recipe'

export default Recipe
// eslint-disable-next-line import/export
export * from './Recipe'
